import api from '@/api'

export default {
  async getOrganizationSites(context, payload) {
    const options = {
      filters: { isEnabled: true },
    }
    if (payload.page) options.page = payload.page
    if (payload.limit) options.limit = payload.limit
    if (payload.filters)
      options.filters = { ...options.filters, ...payload.filters }
    if (payload.sort) options.sort = payload.sort

    const response = await api.organization.getOrganizationSites(
      payload.organizationId,
      options
    )

    return response?.data
  },
}
